import './css/loading.css';
import Loading from './service';
import vLoading from './directive';

export const VixLoading = {
  install(app) {
    app.directive('vixloading', vLoading);
    app.config.globalProperties.$vixLoading = Loading;
  },
  service: Loading,
  directive: vLoading
};

export default VixLoading;
export { vLoading, Loading as VixLoadingService };
